import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "send-link-buttons"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-message me-16",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-message me-16",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.message)), 1),
    (_ctx.url)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_button, {
            variant: "primary",
            class: "btn-icon me-24",
            "aria-label": _ctx.$t('Enviar correo electrónico'),
            onClick: _ctx.sendUrlToPatientViaMail
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Email')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]),
          _createVNode(_component_v_button, {
            variant: "primary",
            class: "btn-icon me-24",
            "aria-label": _ctx.$t('Enviar SMS'),
            onClick: _ctx.sendUrlToPatientViaSMS
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('SMS')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}